import { isNil } from 'lodash-es';
import { navigateAction } from 'fluxible-router';
import { getSpotId } from '../../../../../services/app-state';
import ErrorNotifier from '../../../../../services/error-notifier';
import {
  Folder,
  IAdvancedFilters,
  IPageInfo,
  MessagePublishedStatus,
  MessageType,
  ModeratedBy,
  ModerationSearchType
} from '../types';

interface ModerationNavigateOptions {
  type: 'COMMENTS' | 'POSTS';
  itemsOnPage: number;
  pageInfo: IPageInfo;
  searchValue: string;
  searchType: ModerationSearchType;
  filters: IAdvancedFilters;
}

export function navigateInModeration(
  context: any,
  {
    type = 'COMMENTS',
    itemsOnPage = 20,
    pageInfo,
    filters,
    searchValue,
    searchType
  }: ModerationNavigateOptions,
  done
) {
  const spotId: string = getSpotId();
  let pageNum = 0;

  // Navigate based on the new pageInfo
  try {
    const { tag, folder, offset, messageType, sortBy, published, moderatedBy } = pageInfo;
    const filteringByPublished = folder === Folder.PENDING || folder === Folder.ALL;

    if (offset > 0) {
      pageNum = 1 + offset / itemsOnPage;
    }

    let url = `/spot/${spotId}/moderation/${type?.toLowerCase()}/folder/${folder}/tag/${tag}${
      pageNum ? `/${pageNum}` : ''
    }`;

    const defaultQueryParamsValues = { ...filters, sortBy };

    const advancedAndSearchFilters = searchValue
      ? { ...defaultQueryParamsValues, search: searchValue, searchBy: searchType }
      : defaultQueryParamsValues;

    const queryParams: Record<string, string> = Object.keys(advancedAndSearchFilters).reduce(
      (acc, curr) => {
        return advancedAndSearchFilters[curr]
          ? { ...acc, [curr]: advancedAndSearchFilters[curr] }
          : acc;
      },
      {}
    );

    if (messageType !== MessageType.ALL) {
      queryParams.messageType = messageType;
    }

    if (published !== MessagePublishedStatus.ALL && filteringByPublished) {
      queryParams.published = published;
    }

    if (moderatedBy !== ModeratedBy.ALL) {
      queryParams.moderatedBy = moderatedBy;
    }

    if (Object.keys(queryParams).length) {
      url = extendUrlWithQueryParams(url, queryParams);
    }

    context.executeAction(navigateAction, { url });
  } catch (error) {
    console.error(error);
    ErrorNotifier.notifyError(`Failed to navigate in moderation tab`, {
      type,
      pageInfo,
      filters,
      search: `${searchType}: ${searchValue}`,
      error: error.message
    });
  }
}

function extendUrlWithQueryParams(url: string, queryParams: Record<string, string>) {
  return (
    url +
    '?' +
    Object.keys(queryParams)
      .filter(param => !isNil(queryParams[param]))
      .map(param => `${param}=${queryParams[param]}`)
      .join('&')
  );
}
